import { Mask } from './Mask';
import { TrimMask } from './TrimMask';
import { dom } from '@Engage.Core';
export var TemplateTypes;
(function (TemplateTypes) {
    TemplateTypes["Banner"] = "mg2bn";
    TemplateTypes["Modal"] = "modal";
    TemplateTypes["InfoBox"] = "info-box";
    TemplateTypes["Inline"] = "inline";
})(TemplateTypes || (TemplateTypes = {}));
export class FadeMask extends Mask {
    constructor(maskingOptions) {
        super(maskingOptions);
        this.fadeClass = 'Mg2-fade';
        if (!this.maskElement)
            return; // selector not found
        this.trimMask = new TrimMask(this.maskingOptions);
        if (!dom.hasClass(this.maskElement.lastElementChild || this.maskElement, this.fadeClass)) {
            this.fadeContent(this.maskElement);
        }
        this.trimMask;
    }
    fadeContent(element) {
        const insertHTML = `<div class="${this.fadeClass}"></div>`;
        if (this.maskingOptions.TemplateType === TemplateTypes.Inline) {
            const lastChildContent = this.getLastChildContent(element);
            dom.append(lastChildContent, insertHTML);
        }
        else {
            dom.append(element, insertHTML);
        }
    }
    getLastChildContent(element) {
        var _a, _b, _c, _d, _e;
        let lastTrim = (_c = (_b = (_a = this.trimMask) === null || _a === void 0 ? void 0 : _a.trimMask) === null || _b === void 0 ? void 0 : _b.getLastTrimNode) === null || _c === void 0 ? void 0 : _c.call(_b);
        if (!lastTrim && ((_e = (_d = this.trimMask) === null || _d === void 0 ? void 0 : _d.trimMask) === null || _e === void 0 ? void 0 : _e.getLastTrimElement))
            lastTrim = this.trimMask.trimMask.getLastTrimElement();
        return (lastTrim === null || lastTrim === void 0 ? void 0 : lastTrim.parentNode) || element;
    }
}
